import { ComponentProps, FC } from 'react';
import { Badge } from '@ibsys/kit';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';

type Props = {
  isActive: boolean;
  active?: React.ReactNode;
  notActive?: React.ReactNode;
} & Partial<ComponentProps<typeof Badge>>;

export const IsActiveBadge: FC<Props> = ({ isActive, className, active, notActive, ...props }) => {
  const { t } = useTranslation(['common']);

  return (
    <Badge variant={isActive ? 'primary' : 'destructive'} className={cn('text-xs font-light', className)} {...props}>
      {isActive ? (active ?? t('common:isActive')) : (notActive ?? t('common:isNotActive'))}
    </Badge>
  );
};
